/* eslint-disable no-param-reassign */
import { createSlice, PayloadAction, Slice } from '@reduxjs/toolkit';
import { BENCHMARK_LIST_API } from 'services/constants';
import { BenchmarkListResponse } from 'services/types';
import { isApiFetchingCompletedAction } from '../utils';

const isBenchmarkListApiFullfilledAction =
  isApiFetchingCompletedAction(BENCHMARK_LIST_API);

export interface BenchmarkState {
  selectedBenchmark: string;
  benchmarkList: string[];
}

const initialState: BenchmarkState = {
  selectedBenchmark: '',
  benchmarkList: [],
};

export const benchmarkSlice: Slice<BenchmarkState> = createSlice({
  name: 'benchmarkSlice',
  initialState,
  reducers: {
    updateSelectedBenchmark: (state, action: PayloadAction<string>) => {
      return {
        ...state,
        selectedBenchmark: action.payload,
      };
    },
  },
  extraReducers: (builder) => {
    builder.addMatcher(
      isBenchmarkListApiFullfilledAction,
      (state, action: PayloadAction<BenchmarkListResponse[]>) => {
        const { payload } = action;
        state.selectedBenchmark = payload[0]?.name;
        state.benchmarkList = payload.map((benchmarks) => benchmarks.name);
      }
    );
  },
});

export const { updateSelectedBenchmark } = benchmarkSlice.actions;
